/* global axios */
import ApiClient from './ApiClient';
import { generateFileName } from '../helper/downloadHelper';

class LabelContactsAPI extends ApiClient {
  constructor() {
    super('label_contacts', { accountScoped: true, apiVersion: 'v2' });
  }

  preview({ labelId, from, to, fields }) {
    return axios.get(`${this.url}/preview`, {
      params: {
        label_id: labelId,
        since: from,
        until: to,
        fields,
      },
    });
  }

  export({ labelId, labelName, from, to, fields }) {
    // Generate filename for potential future use
    generateFileName({
      type: `label_contacts_${labelName}`,
      to,
    });

    return axios.get(`${this.url}/export`, {
      params: {
        label_id: labelId,
        since: from,
        until: to,
        fields,
      },
    });
  }
}

export default new LabelContactsAPI();
